const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
};

export default handleCopy;